module.exports = __webpack_public_path__ + "img/avatar_ico5.29a23f85.jpg";